import { Group } from '../types/Group';
import { User } from '../types/User';

export const getInitials = (name = "") =>
    name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2);

export const getGroupNames = (userGroups: (string | { uid: string })[], allGroups: Group[]): string => {
    if (!userGroups || allGroups.length === 0) return '';
    const uids: string[] = userGroups.map((g: string | { uid: string }) => typeof g === 'string' ? g : g.uid);
    return uids
        .map((uid: string) => {
            const group = allGroups.find((g: Group) => g.uid === uid);
            return group ? group.name : '';
        })
        .join(', ');
};

export const getRoleLabel = (user: User) =>
    user.isAdmin ? "администратор" : "оператор";

export type { Group } from '../types/Group';
export type { User } from '../types/User'; 